module.exports = "\r\n<tnsiteheader></tnsiteheader>\r\n<router-outlet></router-outlet>\r\n<tnsitefooter></tnsitefooter>  "


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1